import Component from '@glimmer/component';

import AddButton from 'rise-ui/components/add-button.gjs';

export default class TimeSeriesSelectionOutputActionsAddButtonComponent extends Component {
  <template>
    <span class="c-time-series-selection-line-actions__add">
      <AddButton
        @classMix="c-time-series-selection__add-button qa-time-series-output-add"
        @title={{if @isSelected "Remove from query" "Add to query"}}
        @added={{@isSelected}}
        @linkTo={{@linkTo}}
      />
    </span>
  </template>
}
